export const slugConverter = string => {
  let noSpecialChar = string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return noSpecialChar.replace(/\s/g, "-");
};
